import styled from 'styled-components/macro';

import { Button, Link } from 'components';

export const LinkStyled = styled(Link)`
  display: block;
  text-align: center;
  width: 100%;
`;

export const ButtonStyled = styled(Button)`
  ${({ theme: { spacing } }) => `
    margin: ${spacing?.(4)} 0;
    width: 100%;
  `};
`;

export const ConfirmationModalStyled = styled.div`
  ${({ theme: { typography } }) => `
    ${typography?.(18)}
  `};
`;
